export default __webpack_public_path__ + "static/media/presentation-layer-background.751fbca6.svg";